export default __webpack_public_path__ + "2aac71ae610c73ed96cbecf2b55784d0.svg";